import type { EventDetailsDto } from "@/api/types";
import { AskNobiButton } from "@/components/AskNobi/AskNobiButton";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { DocumentPage } from "@/components/Page/DocumentPage";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

import { EventDetails } from "./components/EventDetails";
import { EventParticipantsCard } from "./components/EventParticipantsCard";

export interface EventDetailsContentProps {
  eventDetails: EventDetailsDto;
}
export function EventDetailsContent(props: EventDetailsContentProps): React.ReactNode {
  const projectId = useProjectId();
  const { t } = useTranslation();
  const slug = useSlug();

  return (
    <DocumentPage
      containerBoundary="inherit"
      tabTitle={props.eventDetails.name.trim() || t("page.event.details.title")}
      breadcrumbs={
        <Breadcrumbs
          pages={[
            {
              name: t("page.calendar.title"),
              to: routes.calendar.list({
                slug,
              }),
            },
            {
              name: t("page.event.details.title"),
            },
          ]}
        />
      }
      actions={
        <AskNobiButton
          defaultFilters={{ projectIds: [projectId] }}
          context={{ scope: "project", entity: "event", page: "detail", entityId: props.eventDetails.id }}
          suggestions={[
            t("component.ask-nobi-chat-drawer.event-detail.suggestion.1"),
            t("component.ask-nobi-chat-drawer.event-detail.suggestion.2"),
          ]}
        />
      }
    >
      <PageGrid.Row>
        <PageGrid.Column size="66%" isDesktopIndifferent>
          <EventDetails event={props.eventDetails} />
        </PageGrid.Column>
        <PageGrid.Column size="33%" isDesktopIndifferent>
          <EventParticipantsCard event={props.eventDetails} />
        </PageGrid.Column>
      </PageGrid.Row>
    </DocumentPage>
  );
}
